'use strict';

import './routes';
import './content';
import './menu';